import { VStack, Wrap } from '@chakra-ui/react';
import React, { useMemo, useCallback } from 'react';
import StandardFormSelect from '../../modules/Form/StandardFormSelect';
import RemovableChip from '../../modules/RemovableChip/RemovableChip';
import { RenderIf } from '../../modules/RenderIf/RenderIf';
const TagSelect = ({ models, selectIds, onChange, isDisabled, ...rest }) => {
    const availableModels = useMemo(() => models.filter(({ id }) => !selectIds.includes(id)), [models, selectIds]);
    const selectedModels = useMemo(() => selectIds
        .map((id) => models.find((e) => e.id === id))
        .filter((model) => model != null), [selectIds, models]);
    const handleSelect = useCallback((modelId) => {
        onChange([...selectIds, modelId]);
    }, [selectIds, onChange]);
    const handleRemove = useCallback((modelId) => {
        onChange(selectIds.filter((id) => id !== modelId));
    }, [selectIds, onChange]);
    return (React.createElement(VStack, { "data-testid": "tag_select", align: "stretch", width: "100%" },
        React.createElement(StandardFormSelect, { ...rest, onChange: handleSelect, isDisabled: isDisabled, groups: [
                {
                    options: availableModels,
                },
            ] }),
        React.createElement(RenderIf, { condition: !!selectedModels.length },
            React.createElement(Wrap, { w: "100%", "data-testid": "selected_models_list" }, selectedModels.map((model) => (React.createElement(RemovableChip, { isDisabled: isDisabled, key: model[rest.nameField], name: model[rest.nameField], onRemove: () => handleRemove(model.id) })))))));
};
export default TagSelect;
